module.exports = __webpack_public_path__ + "static/img/yf_www_code.9cd92ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/print/yf_www_code.jpg
// module id = ij/F
// module chunks = 1